import {useState,useEffect,useContext} from 'react'
import AuthContext from '../../../AuthContext'
import axios from '../../../axios'
const CourseDropdown = ({value,handleInputChange,dont,imp,centre,sector}) => {
  const auth=useContext(AuthContext)
    const [courses, setCourses] = useState([]);
    const [err,setErr]=useState(false)
    useEffect(() => {
      const fetchCourses = async () => {
        try {
          const response = await axios.post('/sector/getJobRoleName',
           {
              sector_id:sector
            }
          );
          if (response.data && Array.isArray(response.data)) {
            setCourses(response.data);
          } else {
            setErr(true); // Handle error if data is unexpected
          }
          // console.log(response.data)
        } catch (error) {
          console.error('Error fetching courses:', error);
        }
      };
  
      fetchCourses();
    }, [sector]);
    return (
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="course-code">
         Job Role {imp && <span className='text-red-500'> *</span>}
        </label>
        <select
          id="course-code"
          value={value}
          onChange={handleInputChange}
          disabled={dont}
          className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${err&&'border-red-600'}`}
          >
            <option value="">Select Job Role</option>
          {courses.map((course,index) => (
            <option key={index} value={course.job_role_name}>
              {course.job_role_name}
            </option>
          ))}
        </select>
      </div>
    );
  };  
  
  export default CourseDropdown;